"use client";

import { EntityMenu, MenuActionType, type ActionGroup } from "@/src/components/menus/entity-menu";

interface CardActionsProps {
  isContextMenu?: boolean;
  id: string;
  label: string;
  href?: string;
  customProps?: { label: string; onClick: () => void }[];
}

export function CardActions({ isContextMenu = false, id, label, href, customProps }: CardActionsProps) {
  const actionGroups: ActionGroup[] = customProps?.length
    ? [customProps.map((prop) => ({ type: MenuActionType.Item, label: prop.label, onClick: prop.onClick }))]
    : [];

  return (
    <EntityMenu
      isContextMenu={isContextMenu}
      entity={{ href, id, label }}
      actionGroups={actionGroups}
      className="w-40"
    />
  );
}

interface CreateCardActionsPropsParams {
  id: string;
  label: string;
  href?: string;
  customProps?: { label: string; onClick: () => void }[];
}

export function createCardActionsProps({ id, label, href, customProps }: CreateCardActionsPropsParams) {
  return {
    id,
    label,
    href,
    customProps,
  };
}
